"use client";

import GlobalScripts from "@/components/layout/GlobalScripts";
import ScrollToTopHandler from "@/components/ScrollToTopHandler";
import useAutoReloadOnConnectionError from "@/hooks/useAutoReloadOnConnectionError";
import { useCookieConsent } from "@/context/CookieConsentContext";

export default function ClientSiteEffects() {
    useAutoReloadOnConnectionError();

    const { consent } = useCookieConsent();
    const shouldLoadThirdParty = process.env.NODE_ENV === "production";
    const canLoadGTMNoscript =
        shouldLoadThirdParty &&
        !!(consent?.analytics || consent?.ads || consent?.personalization);

    return (
        <>
            {canLoadGTMNoscript && (
                <noscript>
                    <iframe
                        src={`https://www.googletagmanager.com/ns.html?id=${
                            process.env.NEXT_PUBLIC_GTM_ID || "GTM-XXXXXXX"
                        }`}
                        height="0"
                        width="0"
                        style={{ display: "none", visibility: "hidden" }}
                    />
                </noscript>
            )}
            {canLoadGTMNoscript ? <GlobalScripts /> : null}
            <ScrollToTopHandler />
        </>
    );
}
